import React, { useState, useEffect, useRef } from 'react';
import './SpaSite.css';
import CourseDetails from './components/CourseDetails';
import ServicesPage from './pages/ServicesPage'; // 路徑依你的實際位置調整
import PromotionsPage from './pages/PromotionsPage';

import QAPage from './pages/QAPage';
import EnvironmentPage from './pages/EnvironmentPage';
import ContactPage from './pages/ContactPage';



export default function NaturalBeautySpa() {
  const [currentPage, setCurrentPage] = useState('home');
  const [animatedElements, setAnimatedElements] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);


  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const [, setCurrentImageIndex] = useState(0);
  const transitionTime = 1500; // ms

  // 我們將管理兩個圖片狀態用於交叉淡入淡出：
  // `currentImage` 是正在淡入/顯示的圖片。
  // `prevImage` 是剛剛淡出或完成淡出的圖片。
  const [currentImage, setCurrentImage] = useState(''); // 初始化為空，會在 useEffect 中設定
  const [prevImage, setPrevImage] = useState(null);
  const [isFadingOutPrev, setIsFadingOutPrev] = useState(false); // 控制舊圖片淡出的狀態
  const [shouldFadeIn, setShouldFadeIn] = useState(false);


  const imageList = [
    '/assets/img/bg2388.jpg',
    '/assets/img/bg2394.jpg',
    '/assets/img/bg2367.jpg',
  ];

  // Ref to hold a reference to the timeout so we can clear it if needed
  const fadeTimeoutRef = useRef(null);

  useEffect(() => {
    // 初始載入第一張
    setCurrentImage(imageList[0]);
    setShouldFadeIn(false);
    const initialRaf = requestAnimationFrame(() => {
      setShouldFadeIn(true);
    });

    const interval = setInterval(() => {
      setCurrentImageIndex(prevIdx => {
        const nextIdx = (prevIdx + 1) % imageList.length;

        // 1. 用 prevImage mount 舊圖，保持 opacity=1
        setPrevImage(imageList[prevIdx]);
        setIsFadingOutPrev(false);

        // 2. 換 currentImage，關閉淡入
        setCurrentImage(imageList[nextIdx]);
        setShouldFadeIn(false);

        // 3. 下一個 frame 觸發舊圖淡出、新圖淡入
        requestAnimationFrame(() => {
          setIsFadingOutPrev(true);
          setShouldFadeIn(true);
        });

        // 4. 轉場結束後移除 prevImage
        fadeTimeoutRef.current = setTimeout(() => {
          setPrevImage(null);
          setIsFadingOutPrev(false);
        }, transitionTime);

        return nextIdx;
      });
    }, 5000);

    return () => {
      clearInterval(interval);
      clearTimeout(fadeTimeoutRef.current);
      cancelAnimationFrame(initialRaf);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 滾動動畫效果
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setAnimatedElements(prev => ({ ...prev, [entry.target.id]: true }));
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.animate-on-scroll').forEach(el => {
      observer.observe(el);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  // Close modal with ESC key
  useEffect(() => {
    const handleEscKey = (e) => {
      if (e.key === 'Escape' && isModalOpen) {
        closeModal();
      }
    };

    document.addEventListener('keydown', handleEscKey);
    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [isModalOpen]);

  const colors = {
    primary: '#1a1a1a',
    secondary: '#4c956c',
    accent: '#d9f2b4',
    light: '#f8faf5',
    neutral: '#336F4D',
    neutralLight: '#505151',
    cream: '#fffaf0',
    gold: '#d4af37',
  };

  const spaSiteStyle = {
    backgroundImage: `linear-gradient(rgba(255, 250, 240, 0.7), rgba(255, 250, 240, 0.9)), url(${process.env.PUBLIC_URL}/assets/img/bg.jpg)`,
    backgroundAttachment: 'fixed',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    fontFamily: '"Noto Serif TC","Microsoft JhengHei", "PingFang TC", serif',
    color: colors.neutral,
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0',
    textAlign: 'center',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };





  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedCourse(null);
    document.body.style.overflow = 'auto';
  };



  const pages = [
    { label: '首頁', id: 'home' },
    { label: '京采周年慶優惠', id: 'promotions' },
    { label: '環境介紹', id: 'environment' },
    { label: '課程介紹', id: 'courses' },
    { label: '常見問題', id: 'qa' },
    { label: '聯絡我們', id: 'contact' },

  ];






  return (
    <div className="spa-site" style={spaSiteStyle}>
      {/* Header with navigation */}
      <header className="site-header" style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0.5rem 2rem',
        background: 'linear-gradient(to bottom, rgba(185, 196, 189, 0.41), rgba(185, 196, 189, 0))',
        backdropFilter: 'blur(10px)',
        boxShadow: '2px 2px 15px rgba(0, 0, 0, 0.05)',
        position: 'sticky',
        top: 0,
        zIndex: 100,
        marginBottom: '0',
        transition: 'all 0.3s ease'
      }}>
        <div className="logo-container" style={{ display: 'flex', alignItems: 'right' }}>
          <img
            src="/assets/img/logo.jpg"
            alt="JC Spa Logo"
            style={{
              width: '40px',
              height: '40px',
              marginRight: '0.75rem',
              borderRadius: '50%',
              objectFit: 'cover'
            }}
          />
          <div className="brand-logo" style={{
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            transition: 'transform 0.3s ease',
          }}>

            <span style={{
              letterSpacing: '0.5px',
              fontSize: '1.2rem',
              color: colors.neutral,
              fontFamily: '"Great Vibes", "Microsoft JhengHei", "PingFang TC", serif',
              fontWeight: 'normal',
              position: 'relative',
              top: '3px'
            }}>Jing Cai</span>
          </div>
        </div>
        {/* 桌面版導航欄 - 只在非手機版顯示 */}
        {!isMobile && (
          <nav style={{ display: 'flex', gap: '1rem' }}>
            {pages.map(({ label, id }) => {
              const active = currentPage === id;
              return (
                <button
                  key={id}
                  onClick={() => {
                    setCurrentPage(id);
                    scrollToSection(id);
                  }}
                  style={{
                    background: currentPage === active ? colors.neutral : 'transparent',
                    color: currentPage === active ? 'white' : colors.neutral,
                    border: 'none',
                    borderRadius: '999px',
                    padding: '1rem',
                    fontWeight: 600,
                    fontSize: '1rem',
                    fontFamily: '"Noto Serif TC"',
                    letterSpacing: '1px',
                    transition: 'all 0.3s ease',
                    position: 'relative',
                    overflow: 'visible',
                    whiteSpace: 'nowrap',
                    cursor: 'pointer',
                    zIndex: 1,
                  }}
                >
                  {label}
                </button>
              );
            })}
          </nav>
        )}





      </header>

      <section id="home" style={{
        position: 'relative',
        overflow: 'hidden',
        height: '100vh', // <<< 新增或確保有明確高度
        width: '100vw', // <<< 確保覆蓋整個視窗寬度
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>        {/* 前一個圖片層 (淡出) */}
        {prevImage && (
          <div
            className={`hero-bg ${isFadingOutPrev ? 'fade-out-image' : ''}`}
            style={{
              backgroundImage: `url(${prevImage})`,
              zIndex: 1, // 確保它在淡出時位於新圖片下方
            }}
          />
        )}

        {/* 當前圖片層 (淡入) */}
        {/* 即使沒有實際淡入動畫，這個 div 也應該始終存在，並根據 currentImage 顯示 */}
        <div
          className={`hero-bg ${shouldFadeIn ? 'fade-in-image' : ''}`}
          style={{ backgroundImage: `url(${currentImage})`, zIndex: 2 }}
        />


        {/* Hero content and scroll indicator */}
        <div className="hero-container" style={{ position: 'relative', zIndex: 3 }}>
          <div className="hero-content">
            <div className="brand-symbol">✦</div>
            <h1 className="main-heading fade-in">京采再生美學Spa</h1>
            <div className="divider"><div className="divider-shine" /></div>
            <p className="main-description"></p>
            <p className="sub-description">
              給自己一個寧靜、深層放鬆的時光<br />
              從頭到腳，全方位再生呵護<br />
              在環境舒適的氛圍中<br />
              感受真正的身心平衡。
            </p>
          </div>
        </div>

        <div className="scroll-indicator" style={{ position: 'relative', zIndex: 3 }}>
          <div style={{ marginBottom: '0.5rem', opacity: 0.8 }}>探索更多</div>
          <div style={{ fontSize: '1.5rem', opacity: 0.6 }}>↓</div>
        </div>
      </section>

      <PromotionsPage />
      <ServicesPage />
      <EnvironmentPage />
      <QAPage />
      {/*<About />*}
      {/* Contact Section with Elevated Design */}
      <ContactPage animatedElements={animatedElements} colors={colors} />
      {/* Course Detail Modal */}
      {isModalOpen && selectedCourse && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
          backdropFilter: 'blur(5px)',
          animation: 'fadeIn 0.3s ease'
        }}>
          <div className="modal-content" style={{
            backgroundColor: 'white',
            borderRadius: '16px',
            width: '90%',
            maxWidth: '800px',
            maxHeight: '90vh',
            overflow: 'hidden',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            animation: 'slideUp 0.4s ease'
          }}>
            {/* Close button */}
            <button
              onClick={closeModal}
              style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                width: '36px',
                height: '36px',
                borderRadius: '50%',
                background: 'rgba(255, 255, 255, 0.8)',
                border: 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                zIndex: 10,
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                transition: 'all 0.2s ease',
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={colors.textDark} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
            <CourseDetails selectedCourse={selectedCourse} colors={colors} />


          </div>
        </div>
      )}
      {isMobile && (
        <>
          {/* 浮動漢堡按鈕 */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            style={{
              position: 'fixed',
              bottom: '2rem',
              right: '2rem',
              width: '56px',
              height: '56px',
              borderRadius: '50%',
              background: colors.secondary,
              color: 'white',
              border: 'none',
              fontSize: '1.5rem',
              boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
              cursor: 'pointer',
              zIndex: 999,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.3s ease',
              transform: mobileMenuOpen ? 'rotate(90deg)' : 'rotate(0deg)'
            }}
          >
            {mobileMenuOpen ? '✕' : '☰'}
          </button>

          {/* 全屏遮罩 + 選單 */}
          {mobileMenuOpen && (
            <>
              {/* 背景遮罩 */}
              <div
                onClick={() => setMobileMenuOpen(false)}
                style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'rgba(0, 0, 0, 0.5)',
                  zIndex: 998,
                  animation: 'fadeIn 0.3s ease'
                }}
              />

              {/* 選單面板 */}
              <div style={{
                position: 'fixed',
                bottom: '5rem',
                right: '2rem',
                background: 'white',
                borderRadius: '16px',
                padding: '1rem',
                boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
                zIndex: 999,
                minWidth: '200px',
                animation: 'slideUp 0.3s ease'
              }}>
                {pages.map(({ label, id }) => (
                  <button
                    key={id}
                    onClick={() => {
                      setCurrentPage(id);
                      scrollToSection(id);
                      setMobileMenuOpen(false);
                    }}
                    style={{
                      width: '100%',
                      background: currentPage === id ? colors.secondary : 'transparent',
                      color: currentPage === id ? 'white' : colors.neutral,
                      border: 'none',
                      borderRadius: '8px',
                      padding: '1rem',
                      marginBottom: '0.5rem',
                      fontWeight: 600,
                      fontSize: '1rem',
                      fontFamily: '"Noto Serif TC"',
                      cursor: 'pointer',
                      textAlign: 'left',
                      transition: 'all 0.2s ease'
                    }}
                  >
                    {label}
                  </button>
                ))}
              </div>
            </>
          )}
        </>
      )}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes slideUp {
          from { transform: translateY(30px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        
        .modal-overlay {
          -webkit-animation: fadeIn 0.3s ease;
          animation: fadeIn 0.3s ease;
        }
        
        .modal-content {
          -webkit-animation: slideUp 0.4s ease;
          animation: slideUp 0.4s ease;
        }
      `}</style>
    </div>


  )
}